////////LIBRARY/////////
import React, { useState, useEffect, useRef, Fragment } from 'react'
import { useDispatch, useSelector, shallowEqual } from 'react-redux'
import styled from 'styled-components'
import { bindActionCreators } from 'redux'
import { useForm } from 'react-hook-form'
import { isEmpty, isUndefined, cloneDeep, reject, map, filter, find, includes } from 'lodash'
///////COMPONENTS///////
import { kioskPerimeterActionCreators, toastSuccessActionCreators } from '../../store/actions'
import DynamicPerimeter from './DynamicPerimeter'
import StaticPerimeter from './StaticPerimeter'
import ToggleFilters from '../Ui/ToggleFilters'
import Dropdown from '../Ui/Dropdown'
import theme from '../../theme/theme'
import Tooltip from '../Tooltip/Tooltip'
import {
	InputLogin,
	PageTitle,
	SearchInputButton,
	SearchInputWrapper,
	ToggleWrapper,
	PageWrapperActionValidate,
	PageWrapperActionReset,
	PageWrapperActionTrash,
	PageWrapperActionPrevPage,
	SearchReset,
	TextModal,
	ButtonWrapper,
	ErrorInputMsg,
	InputWrapper,
} from '../../theme/GlobalCss'
import Modals from '../Modals'
import Button from '../Ui/Buttons'
import ListEditable from '../../components/ListEditable'
import TooltipHelp from '../TooltipHelp'
/////////ASSETS/////////
import SettingsActiveIcon from '../../assets/icones/kioskPerimeter/settings-active.svg'
import HandClickActiveIcon from '../../assets/icones/kioskPerimeter/hand-click-active.svg'
import SettingsDesactiveIcon from '../../assets/icones/kioskPerimeter/settings-desactive.svg'
import HandClickDesactiveIcon from '../../assets/icones/kioskPerimeter/hand-click-desactive.svg'
import Validation from '../../assets/icones/global/check.svg'
import Close from '../../assets/icones/global/close-white.svg'
import Save from '../../assets/icones/global/save.svg'
import update from 'immutability-helper'

/////////STYLED/////////
const KioskPerimeterWrapper = styled.div`
	display: flex;
	flex-direction: column;
	width: 1fr;
	font-size: ${(props) => props.theme.font.fs};
`
const ConfigLine = styled.div`
	display: flex;
	justify-content: flex-end;
	align-items: center;
	width: 100%;
	height: 32px;
`
const ConfigWrapper = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
`
const ConfigUnit = styled.div`
	display: flex;
	align-items: center;
	& > * {
		margin: 5px;
	}
	& > * > * > select {
		font-size: ${(props) => props.theme.font.fs} !important;
	}
`
const ConfigSplitter = styled.div`
	margin: 0 10px;
	height: 32px;
	border-left: 1px solid ${(props) => props.theme.colors.TabNav.border};
`
const PerimeterBody = styled.div`
	display: grid;
	grid-template-columns: 0.66fr 0.33fr;
	grid-column-gap: 20px;
	margin-top: 15px;
	height: 655px;
`
export const LineTableHeader = styled.div`
	display: grid;
	grid-template-columns: max-content repeat(auto-fit, max-content);
	grid-auto-flow: column;
	grid-column-gap: 16px;
	grid-template-rows: max-content;
	grid-auto-rows: 32px;
	justify-content: space-between;
	align-items: center;
	width: 100%;
	box-sizing: border-box;
`
const ResultWrapper = styled.div`
	display: flex;
	flex-direction: column;
	border-radius: 4px;

	position: relative;
	border: ${(props) => `1px solid ${props.theme.colors.primary}`};

	& > div {
		border-radius: 0px;
		border: 0px;
	}
`
const WarningBody = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
`
const PageGridTitleStyled = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	color: ${(props) => props.theme.colors.white};
	background-color: ${(props) => props.theme.colors.primary};
	padding: 13px;
`
const PageGridTitleStyledSpan = styled.span`
	display: block;
	margin: auto;
	& > b {
		font-size: ${(props) => props.theme.font.fl};
	}
`
const ListActions = styled.div`
	position: relative;
	padding: 10px;
	display: flex;
	flex-direction: row;
	&:nth-child(2) {
		border-bottom: 1px solid ${(props) => props.theme.colors.TabNav.border};
	}
	justify-content: space-between;
`
const KioskSearchWrapper = styled.div`
	position: relative;
	& > * > input {
		font-size: ${(props) => props.theme.font.fs};
	}
	display: flex;
	flex-direction: row;
`
const RowsSelectedCounter = styled.span`
	font-weight: bold;
	color: ${(props) => props.theme.colors.primary};
`
const TextModalSpan = styled.span`
	font-weight: bold;
	color: ${(props) => props.theme.colors.primary};
`
const ButtonWrapperApply = styled(ButtonWrapper)`
	position: absolute;
	right: 20px;
	bottom: 20px;
	max-width: 210px;
`
const ButtonWrapperForm = styled(ButtonWrapper)`
	& button {
		margin-right: 0px;
	}
	& > div {
		width: 210px;
	}
`
const LanguagePartLabel = styled.label``
/////////STYLED/////////

const KioskPerimeter = (props) => {
	const { translations, user, kioskPerimeter } = useSelector(
		(state) => ({
			translations: state.languages.translations,
			user: state.user,
			kioskPerimeter: state.kioskPerimeter,
		}),
		shallowEqual
	)

	const [stateDefaultValues, setStateDefaultValues] = useState({
		perimeter: null,
	})

	const [stateDefaultValuesValidation, setStateDefaultValuesValidation] = useState({
		nameNewKioskScope: null,
	})

	const [isSaveAs, setIsSaveAs] = useState(false)
	const [showStatic, setShowStatic] = useState(false)
	const [alertSwitch, setAlertSwitch] = useState(false) // For switching mode
	const [perimetersList, setPerimetersList] = useState([]) // List of perimeters
	const [listTagSelected, setListTagSelected] = useState([]) // List of selected tags
	const [listKiosksSelected, setListKiosksSelected] = useState([]) // List of selected kiosks => all selected by default on back call

	const [inputDataKiosk, setInputDataKiosk] = useState(user?.identity?.kioskSelected)
	const [sortDir, setSortDir] = useState(1)
	const [searchValueKiosk, setSearchValueKiosk] = useState('')
	const [searchedKiosk, setSearchedKiosk] = useState('')

	const [listUnaffected, setListUnaffected] = useState([]) // List of checked unaffected users/kiosks (ids)
	const [listObjUnaffected, setListObjUnaffected] = useState([]) // List of moved unaffected items (objects) => is constantly refreshed

	const [listObjAffected, setListObjAffected] = useState([]) // List of moved affectd items (objects) => is constantly refreshed

	const [baseSearch, setBaseSearch] = useState() // Database of searching

	const [showValidationModal, setShowValidationModal] = useState(false)
	const [showConfirmModal, setShowConfirmModal] = useState(false)

	const [resetDefValues, setResetDefValues] = useState(0)
	const [idPerimeter, setIdPerimeter] = useState(null)
	// Stored criterias for validation
	const [criterionsSelected, setCriterionsSelected] = useState({
		isDisabled: null,
		paymentByCode: null,
		solarPanel: null,
		scale: null,
		bottleDetection: null,
		installationDateStart: null,
		installationDateEnd: null,
		lastUpdateDateStart: null,
		lastUpdateDateEnd: null,
		lastActivationDateStart: null,
		lastActivationDateEnd: null,
		lockersNumber: null,
		operator: null,
		ipAddress: null,
		model: null,
		appVersion: null,
		label: null,
		idLanguage: 2,
	})

	// For perimeters selector
	const { register, handleSubmit, setValue, getValues } = useForm({
		defaultValues: stateDefaultValues,
	})

	// For validation modal
	const {
		register: registerValidation,
		handleSubmit: handleSubmitValidation,
		errors: errorsValidation,
		setValue: setValueValidation,
		getValues: getValuesValidation,
	} = useForm({
		defaultValues: stateDefaultValuesValidation,
	})

	const columnsKiosk = [
		// We set what data value is used to
		// For setting value of input
		{ isRemovableValue: showStatic, dataHook: 'id', headerName: 'id', sortable: false },
		// For labelling the item
		{
			isLabel: true,
			dataHook: 'labelToDisplay',
			headerName: 'labelToDisplay',
			sortable: true,
			alreadyTranslated: true,
			additionalLabelName: 'store',
		},
	]

	///////////////////////////////// HANDLE ///////////////////////////////////////

	const handleSwitchView = () => {
		setShowStatic((prev) => !prev)
		if (showStatic) {
			// If we go dynamic mode
			//actionsKioskPerimeter.resetKiosksScope() // Reset what is stored
			setListKiosksSelected(map(user?.identity?.kiosksPool, 'id')) // Reset what was selected
			setInputDataKiosk(user?.identity?.kiosksPool)
		}
		handleSwitchAlert()
	}
	const handleSwitchAlert = () => {
		setAlertSwitch((prev) => !prev)
	}

	const handleFormSubmit = (data) => {
		if (!isUndefined(data.perimeter) && parseInt(data.perimeter) > 0) {
			actionsKioskPerimeter.getPerimeter(data.perimeter)
		} else {
			// Reset kiosks selected list
			//actionsKioskPerimeter.resetKiosksScope()
			setListKiosksSelected([])
			setListTagSelected(map(user.identity.tags.tags, 'id')) // Back to what tags have user
		}
	}

	const actionsKioskPerimeter = bindActionCreators(kioskPerimeterActionCreators, useDispatch())

	const handleInputDataKiosk = (triggerShift, arrToPass) => {
		let newinputData = cloneDeep(inputDataKiosk)

		let newListKiosksSelected = cloneDeep(listKiosksSelected)

		// Every item that was in affected list (checked items), we add to this list
		if (listObjUnaffected.length > 0) {
			map(listObjUnaffected, (elem, _id) => {
				if (!isUndefined(elem)) {
					const r = filter(newinputData, (o) => o.id === elem.id)

					const f = !!find(newListKiosksSelected, elem.id)
					if (!f) newListKiosksSelected.push(elem.id)

					// If affected item is not in our current list, we add it
					return r.length === 0 ? newinputData.push(elem) : null
				}
			})
		}

		// But also cutting objects that were shifted,
		// at any time so filters can work properly
		if (triggerShift) {
			map(arrToPass, (elem) => {
				newinputData = reject(newinputData, elem)
			})
			// Send items to affected manager
			props.setListObjUnaffected(arrToPass)
			// Reset checked list
			props.setListUnaffected([])
		}
		if (isUndefined(newListKiosksSelected[0])) newListKiosksSelected = newinputData
		if (!isUndefined(user.identity.kiosksSelected)) setInputDataKiosk(user.identity.kiosksSelected)
		setListKiosksSelected(newListKiosksSelected)
		// Everytime that items are added / remove, we redraw the search base
		setBaseSearch(newinputData)
	}

	const handleSearchValue = (e) => {
		setSearchValueKiosk(e.target.value)
	}

	const handleSearch = (_e) => {
		setSearchedKiosk(searchValueKiosk)
	}

	const handleSearchEnter = (e) => {
		if (e.keyCode === 13 || searchValueKiosk === '') setSearchedKiosk(searchValueKiosk)
	}

	// Handling of filters
	const handleGlobalSearch = () => {
		// Note that we always start from searchBase, not current input,
		// Otherwise everytime we are filtering, we are removing elements !
		if (!isUndefined(baseSearch)) {
			let b_s = cloneDeep(baseSearch)

			if (searchValueKiosk.length > 0) {
				b_s = reject(b_s, (o) => {
					let str = cloneDeep(o.labelToDisplay)
					str = str.normalize('NFD').replace(/[\u0300-\u036f]/g, '')
					let transformed_search = cloneDeep(searchedKiosk)
					transformed_search = transformed_search.normalize('NFD').replace(/[\u0300-\u036f]/g, '')
					return str.toUpperCase().includes(transformed_search.toUpperCase()) ? false : true
				})
			}
			if (!isUndefined(b_s)) setInputDataKiosk(b_s)
		}
	}

	const refListKiosksSelected = useRef()

	const handleListObjAffected = () => {
		// Here, we are not adding item to arrToPass,
		// but rather start from base and filter items that are removed (hidden in fact)
		// We need to start from the ref, not the complete list !
		let arrToPass = []
		let ids = refListKiosksSelected.current
		map(listKiosksSelected, (elem) => {
			ids = reject(ids, (o) => o === elem)
		})

		arrToPass.push(find(inputDataKiosk, (o) => o.id === ids[0]))

		setListObjAffected(arrToPass)
	}

	const onSubmitValidation = (data) => {
		let datas = cloneDeep(data)
		datas.criterionsSelection = criterionsSelected
		datas.tags = listTagSelected
		datas.kiosks = listKiosksSelected
		datas.isStatic = showStatic

		const idPerimeter = kioskPerimeter.kioskPerimeterDetail.id

		if (!isUndefined(idPerimeter) && !isSaveAs) {
			actionsKioskPerimeter.updatePerimeter(datas, idPerimeter)
			actionsKioskPerimeter.applyPerimeter(datas, idPerimeter)
		} else if (isSaveAs) {
			actionsKioskPerimeter.createPerimeter(datas)
			actionsKioskPerimeter.applyPerimeter(datas, idPerimeter)
			setIsSaveAs(false)
		}
		//actionsKioskPerimeter.getPerimeter(idPerimeter)
		setIdPerimeter(idPerimeter)
	}

	const actionToastSuccess = bindActionCreators(toastSuccessActionCreators, useDispatch())

	// This function does not pass by form,
	// so no need to check for perimeter name
	const onSubmitValidationApply = () => {
		let datas = {}

		datas.kiosks = listKiosksSelected

		// We cannot pass ids here, because we are directly setting in user store
		let arr = reject(user.identity.kiosksPool, (o) => !includes(listKiosksSelected, o.id))
		datas.kiosks = arr

		actionToastSuccess.hydrateToast('toast__kioskScope__admin__applied_success')
		const idPerimeter = kioskPerimeter.kioskPerimeterDetail.id

		actionsKioskPerimeter.applyPerimeter(datas, idPerimeter)
	}

	const handleDeletePerimeter = () => {
		actionsKioskPerimeter.deletePerimeter(kioskPerimeter.kioskPerimeterDetail.id)
	}

	const handleConfirmModal = () => {
		setShowConfirmModal((prevState) => !prevState)
	}

	const handleReset = () => {
		setResetDefValues(resetDefValues + 1)
		const ids = map(user.identity.kioskSelected, 'id')
		setListKiosksSelected(ids)
		if (!isUndefined(user.identity.kiosksPool)) setInputDataKiosk(user.identity.kiosksPool)
	}

	const handleSaveAs = (e) => {
		let isDuplicate = false
		map(kioskPerimeter.items, (elem) => {
			if (elem?.label == e.target.value) isDuplicate = true
		})
		if (isEmpty(e.target.value.replace(/\s/g, ''))) isDuplicate = true
		setIsSaveAs(!isDuplicate)
	}

	/////////////////////////////// USE EFFECT /////////////////////////////////////

	useEffect(() => {
		// If we substract one item from listKiosksSelected and that we ARE in static mode
		if (!isUndefined(refListKiosksSelected.current) && refListKiosksSelected.current.length > listKiosksSelected.length && showStatic) {
			// We are shifting the item
			handleListObjAffected()
		}
		refListKiosksSelected.current = listKiosksSelected
	}, [listKiosksSelected])

	useEffect(() => {
		// Load perimeters
		if (kioskPerimeter?.update) {
			setListKiosksSelected(map(listKiosksSelected, 'id'))
		}
	}, [idPerimeter])

	useEffect(() => {
		// Whenever we change filters we redraw the list
		handleInputDataKiosk()
	}, [listObjUnaffected])

	useEffect(() => {
		handleGlobalSearch()
	}, [searchedKiosk])

	useEffect(() => {
		// Anytime kiosk list changes in store, we redraw the list
		if (!isUndefined(kioskPerimeter?.kioskPerimeterDetail?.kiosksInScope)) {
			setInputDataKiosk(kioskPerimeter?.kioskPerimeterDetail?.kiosksInScope)
			setListKiosksSelected(map(kioskPerimeter.kioskPerimeterDetail.kiosksInScope, 'id'))
		}
	}, [kioskPerimeter.kioskPerimeterDetail.kiosksInScope])

	// Reset tag list when on static mode
	useEffect(() => {
		if (showStatic) setListTagSelected([])
	}, [showStatic])

	// When validation modal is open, we set the name of selected perimeter if any
	useEffect(() => {
		if (kioskPerimeter.kioskPerimeterDetail !== false && parseInt(getValues('perimeter')) > 0 && showValidationModal) {
			let str = map(
				filter(perimetersList, (o) => o.value === parseInt(getValues('perimeter'))),
				'label'
			)
			str = str[0]
			setValueValidation('nameNewKioskScope', str)
			setStateDefaultValuesValidation(getValuesValidation)
		}
	}, [showValidationModal])

	// When we have selected a perimeter, we switch mode based on what mode is the perimeter
	useEffect(() => {
		if (kioskPerimeter.kioskPerimeterDetail !== false) setShowStatic(kioskPerimeter.kioskPerimeterDetail.staticScope)
	}, [kioskPerimeter.kioskPerimeterDetail.staticScope])

	useEffect(() => {
		// Setting perimeters in select
		if (!isEmpty(kioskPerimeter)) setPerimetersList(kioskPerimeter.items)
	}, [kioskPerimeter.items])

	// Setting current perimeter selected by user
	useEffect(() => {
		if (user.identity.idPerimeter > 0 && perimetersList.length > 0 && !isEmpty(kioskPerimeter.items)) {
			setValue('perimeter', user.identity.idPerimeter)
			setStateDefaultValues(getValues)
			let data = {}
			data.perimeter = user.identity.idPerimeter
			// Also back call to load all infos relative to perimeter
			//handleFormSubmit(data)
		}
	}, [kioskPerimeter.items, perimetersList])

	useEffect(() => {
		// On deleting, reset kiosk list.
		// We check that our detail is well initialized, so we don't delete on loading modal...
		if (kioskPerimeter.deleteSuccess && kioskPerimeter.kioskPerimeterDetail !== false) {
			setListKiosksSelected([])
		}
	}, [kioskPerimeter.deleteSuccess])

	useEffect(() => {
		if (
			listKiosksSelected?.length != inputDataKiosk?.length &&
			listKiosksSelected?.length > 0 &&
			listKiosksSelected?.length > inputDataKiosk?.length &&
			!isUndefined(inputDataKiosk) &&
			!!isUndefined(listKiosksSelected)
		) {
			let result = user?.identity?.kiosksPool.find((elem) => {
				return elem.id == listKiosksSelected[listKiosksSelected?.length - 1]
			})
			let newinputDataKiosk = { ...inputDataKiosk }
			newinputDataKiosk.push(result)
			setInputDataKiosk(newinputDataKiosk)
		}
	}, [listKiosksSelected])

	useEffect(() => {
		let result = []
		listKiosksSelected.forEach((kioskSelected) => {
			user.identity.kiosksPool.forEach((kioskPool) => {
				if (kioskSelected == kioskPool.id) result.push(kioskPool)
			})
		})
		setBaseSearch(result)
	}, [listKiosksSelected])

	useEffect(() => {
		actionsKioskPerimeter.getPerimeters()
		if (user?.identity?.idPerimeter && !isUndefined(user?.identity?.idPerimeter) && user?.identity?.idPerimeter != 0) {
			actionsKioskPerimeter.getPerimeter(user?.identity?.idPerimeter)
		}
	}, [])

	///////////////////////////////// RENDER ///////////////////////////////////////

	return (
		<KioskPerimeterWrapper>
			<Modals
				showModal={alertSwitch}
				closeModalHandler={handleSwitchAlert}
				level="error"
				icon={true}
				insideModal
				title={translations['common__text__warning']}
				width={555}
			>
				<WarningBody>
					{!showStatic ? (
						<>
							<p>
								<b>{translations['modal__scopeManagement__dynamic_bold_message']}</b>
							</p>
							<p>{translations['modal__scopeManagement__dynamic_message']}</p>
							<p>{translations['modal__scopeManagement__dynamic_message_note']}</p>
						</>
					) : (
						<>
							<p>
								<b>{translations['modal__scopeManagement__static_bold_message']}</b>
							</p>
							<p>{translations['modal__scopeManagement__static_message']}</p>
						</>
					)}

					<ButtonWrapper>
						<Button
							text={translations['common__text__cancel']}
							img={Close}
							bgColor={theme.colors.error}
							actionHandler={handleSwitchAlert}
							margin="true"
						/>

						<Button
							text={translations['common__text__validate']}
							img={Validation}
							bgColor={theme.colors.validation}
							actionHandler={handleSwitchView}
						/>
					</ButtonWrapper>
				</WarningBody>
			</Modals>
			<Modals
				showModal={showValidationModal}
				insideModal
				title={translations['modal__kioskScope__admin__saveScope__title']}
				closeModalHandler={() => setShowValidationModal(false)}
				minWidth={670}
				icon={true}
			>
				<Fragment>
					<form onSubmit={handleSubmitValidation(onSubmitValidation)}>
						<TextModal style={{ textAlign: 'center' }}>
							{kioskPerimeter.kioskPerimeterDetail.id && (
								<p>
									{translations['modal__kioskScope__admin__saveScope__content__scope']} :{' '}
									<TextModalSpan>
										"{/* {getValuesValidation('nameNewKioskScope')} */}
										{map(kioskPerimeter.items, (elem) => {
											if (elem?.value == kioskPerimeter?.kioskPerimeterDetail?.id) return elem?.label
										})}
										"
									</TextModalSpan>
								</p>
							)}
							<p>{translations['modal__kioskScope__admin__saveScope__content__choiceAction']}</p>
							<InputWrapper>
								<InputLogin
									onChange={(e) => handleSaveAs(e)}
									name="nameNewKioskScope"
									type="text"
									placeholder={translations['page__stockManagement__admin__scopeName_placeholder']}
									ref={registerValidation({
										required: {
											value: true,
											message: translations['common__text__requiredField'],
										},
										maxLength: {
											value: 150,
											message: '',
										},
									})}
								/>
								{errorsValidation.nameNewKioskScope && <ErrorInputMsg>{errorsValidation.nameNewKioskScope.message}</ErrorInputMsg>}
							</InputWrapper>
						</TextModal>

						<ButtonWrapperForm>
							<Button
								text={translations['modal__kioskScope__admin__saveScope__content__action_saveAs']}
								bgColor={theme.colors.primary}
								margin="true"
								img={Save}
								disabled={!isSaveAs}
							/>
							<Button
								text={translations['modal__kioskScope__admin__saveScope__content__action_save']}
								bgColor={theme.colors.primary}
								margin="true"
								img={Save}
								disabled={isUndefined(kioskPerimeter?.kioskPerimeterDetail?.id)}
							/>
							<div></div>
						</ButtonWrapperForm>
					</form>
					<ButtonWrapperApply>
						<Button
							actionHandler={() => onSubmitValidationApply()}
							text={translations['modal__kioskScope__admin__saveScope__content__action_appliedOnly']}
							bgColor={theme.colors.validation}
							img={Validation}
							padding={15}
							noHash
						/>
					</ButtonWrapperApply>
				</Fragment>
			</Modals>
			<Modals
				showModal={showConfirmModal}
				insideModal
				title={translations['modal__kioskScope__admin__title__deleteScope_confirm']}
				closeModalHandler={() => setShowConfirmModal(false)}
				icon={true}
				level="error"
			>
				<TextModal>
					<p>{translations['modal__kioskScope__admin__content__deleteScope_confirm']}</p>
				</TextModal>
				<ButtonWrapper>
					<Button
						actionHandler={handleConfirmModal}
						text={translations['common__text__cancel']}
						bgColor={theme.colors.error}
						margin="true"
						img={Close}
					/>
					<Button
						actionHandler={() => {
							handleDeletePerimeter()
							handleConfirmModal()
						}}
						text={translations['common__text__delete']}
						bgColor={theme.colors.validation}
						img={Validation}
					/>
				</ButtonWrapper>
			</Modals>
			<LineTableHeader>
				<PageTitle>
					{showStatic ? (
						<TooltipHelp content={'page__scopeManagement__static_header'} insideModal>
							{translations['page__scopeManagement__static_title']}
						</TooltipHelp>
					) : (
						<TooltipHelp content={'tooltipHelp__admin__modal__body__scopeManagement__selectTagCriterion'} insideModal>
							{translations['page__scopeManagement__dynamic_title']}
						</TooltipHelp>
					)}
				</PageTitle>
				<ConfigLine>
					<ConfigWrapper>
						<ConfigUnit>
							<ToggleWrapper>
								<TooltipHelp content={'tooltipHelp__admin__modal__body__scopeManagement__staticDynamic'} childrenPos={2} insideModal>
									<Tooltip
										translationsKey={'tooltip__admin__scopeManagement__filter__switch_staticDynamic'}
										tooltipId={'toogleStatic'}
										position={'left'}
									>
										<ToggleFilters
											checked={!showStatic}
											onChangeHandler={handleSwitchAlert}
											size={'large'}
											prevActiveIcon={HandClickActiveIcon}
											prevDesactiveIcon={HandClickDesactiveIcon}
											nextActiveIcon={SettingsActiveIcon}
											nextDesactiveIcon={SettingsDesactiveIcon}
										/>
									</Tooltip>
								</TooltipHelp>
							</ToggleWrapper>
						</ConfigUnit>
						<ConfigSplitter />
						<ConfigUnit>
							<LanguagePartLabel>{translations['page__stockManagement__admin__scopeName_current']} :</LanguagePartLabel>
							<form onSubmit={handleSubmit(handleFormSubmit)}>
								<Dropdown
									list={perimetersList}
									listName={'perimeter'}
									register={register}
									zeroValue={translations['page__admin__scopeManagement__dropdown__zeroValue']}
									onChangeHandler={handleSubmit(handleFormSubmit)}
									target={true}
								/>
							</form>
							<Tooltip
								tooltipId={'kioskScopeDelete'}
								translationsKey={'tooltip__admin__scopeManagement__deleteScope'}
								position={'left'}
							>
								<PageWrapperActionTrash
									unlocked={kioskPerimeter.kioskPerimeterDetail.id > 0}
									disabled={!kioskPerimeter.kioskPerimeterDetail.id > 0}
									onClick={() => kioskPerimeter.kioskPerimeterDetail.id > 0 && setShowConfirmModal(true)}
								/>
							</Tooltip>
						</ConfigUnit>
						<ConfigSplitter />
						<ConfigUnit>
							<Tooltip tooltipId={'kioskScopeReset'} translationsKey={'tooltip__admin__global__reset'} position={'left'}>
								<PageWrapperActionReset onClick={() => handleReset()} />
							</Tooltip>
							<Tooltip tooltipId={'kioskScopeClose'} translationsKey={'tooltip__admin__global__cancelClose'} position={'left'}>
								<PageWrapperActionPrevPage onClick={() => props.closeModal()} />
							</Tooltip>
							<Tooltip tooltipId={'kioskScopeSubmit'} translationsKey={'tooltip__admin__global__save'} position={'left'}>
								<PageWrapperActionValidate unlocked={listKiosksSelected.length > 0} onClick={() => setShowValidationModal(true)} />
							</Tooltip>
						</ConfigUnit>
					</ConfigWrapper>
				</ConfigLine>
			</LineTableHeader>

			<PerimeterBody>
				{showStatic ? (
					<StaticPerimeter
						baseData={user.identity.kiosksPool}
						listObjAffected={listObjAffected}
						listKiosksSelected={listKiosksSelected}
						listUnaffected={listUnaffected}
						setListUnaffected={setListUnaffected}
						setListObjUnaffected={setListObjUnaffected}
					/>
				) : (
					<DynamicPerimeter
						listTagSelected={listTagSelected}
						setListTagSelected={setListTagSelected}
						setCriterions={setCriterionsSelected}
						resetDefValues={resetDefValues}
					/>
				)}
				<ResultWrapper>
					<PageGridTitleStyled>
						<TooltipHelp content={'tooltipHelp__admin__modal__body__scopeManagement__kioskList'} altImg insideModal>
							{translations['page__scopeManagement__result_selection']}
						</TooltipHelp>
						<PageGridTitleStyledSpan>
							{
								<b>
									{translations['page__scopeManagement__result_scope']} : {listKiosksSelected.length} /{' '}
									{user.identity.kiosksPool.length}
								</b>
							}
						</PageGridTitleStyledSpan>
					</PageGridTitleStyled>
					<ListActions>
						<KioskSearchWrapper>
							<SearchInputWrapper>
								<InputLogin
									value={searchValueKiosk}
									onChange={handleSearchValue}
									onKeyDown={handleSearchEnter}
									placeholder={translations['page__tagManagement__kiosk_search']}
								/>
								<SearchInputButton onClick={handleSearch} />
							</SearchInputWrapper>
							{searchValueKiosk.length > 0 && (
								<SearchReset
									onClick={() => {
										setSearchValueKiosk('')
										setSearchedKiosk('')
									}}
								/>
							)}
						</KioskSearchWrapper>
						{showStatic && (
							<Button
								text={translations['page__scopeManagement__button_clear']}
								disabled={!showStatic}
								actionHandler={() => setListKiosksSelected([])}
							/>
						)}
					</ListActions>
					<ListActions>
						<Tooltip translationsKey={'tooltip__admin__scopeManagement__filter__sort_storeName'} tooltipId={'scopeKioskSortKiosk'}>
							<ToggleFilters
								checked={sortDir}
								onChangeHandler={() => {
									setSortDir(sortDir === 0 ? 1 : 0)
								}}
								name="columnSort"
								labelPrev="AZ"
								labelNext="ZA"
								reverseCheck
							/>
						</Tooltip>
						<div>
							<RowsSelectedCounter>
								{!isUndefined(listKiosksSelected) && listKiosksSelected?.length} / {user?.identity?.kiosksPool?.length}
							</RowsSelectedCounter>{' '}
							{translations['page__scopeManagement__result_kiosk_found']}
						</div>
					</ListActions>{' '}
					{inputDataKiosk?.length > 0 && !isEmpty(inputDataKiosk) && !isEmpty(listKiosksSelected) && !isEmpty(columnsKiosk) && (
						<ListEditable
							inputData={baseSearch}
							inputColumns={columnsKiosk}
							type="removable"
							translationMode={true}
							sortColumnName={'labelToDisplay'}
							sortDir={sortDir}
							listSelected={setListKiosksSelected}
							sizeHeightActions={320}
							removableList={isUndefined(listKiosksSelected[0]?.labelToDisplay) ? listKiosksSelected : map(listKiosksSelected, 'id')}
							ref={refListKiosksSelected}
							fixedBaseHeight={750}
						/>
					)}
				</ResultWrapper>
			</PerimeterBody>
		</KioskPerimeterWrapper>
	)
}

KioskPerimeter.propTypes = {}

KioskPerimeter.defaultPropTypes = {}

export default KioskPerimeter
